import React, { useState } from 'react';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { CustomExpander } from '../../../../../../components/CustomExpander/CustomExpander';

export interface WorkingHoursSideBarFilterDatemodel {
  onSearch: (startDate: Date, endDate: Date) => any;
}
export const WorkingHoursSideBarFilter: React.FC<
  WorkingHoursSideBarFilterDatemodel
> = ({ onSearch }) => {
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);

  const handleStartDateChange = (date: Date | null) => {
    setStartDate(date);
  };

  const handleEndDateChange = (date: Date | null) => {
    setEndDate(date);
  };

  const handleApprove = () => {
    if (startDate && endDate) {
      onSearch(startDate, endDate);
    }
  };

  const styles = {
    container: {
      height: '100%',
      background: 'white',
      borderRadius: '8px',
      padding: '16px',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      flexDirection: 'column' as const,
    },
    header: {
      fontSize: '1.2rem',
      fontWeight: 'bold',
      marginBottom: '16px',
      color: '#333',
    },
    content: {
      flex: 1,
      overflowY: 'auto' as const,
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '8px',
      paddingRight: '4px',
    },
    dateContainer: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '8px',
      padding: '8px',
    },
    calendarWrapper: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '8px',
    },
    calendarLabel: {
      fontSize: '0.9rem',
      color: '#666',
    },
    buttonContainer: {
      marginTop: '16px',
      padding: '8px',
      borderTop: '1px solid #e9ecef',
    },
    approveButton: {
      width: '100%',
      backgroundColor: '#2196F3',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      padding: '12px',
      fontSize: '1rem',
      fontWeight: 'bold',
      cursor: 'pointer',
      transition: 'background-color 0.2s',
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>סינוני שעות עבודה</div>
      <div style={styles.content}>
        <CustomExpander>
          <div>טווח תאריכים</div>
          <div style={styles.dateContainer}>
            <div style={styles.calendarWrapper}>
              <label style={styles.calendarLabel}>תאריך התחלה</label>
              <Calendar
                value={startDate}
                onChange={(e) => handleStartDateChange(e.value as Date)}
                dateFormat="dd/mm/yy"
                showIcon
                iconPos="right"
                style={{
                  height: '36px',
                  width: '100%',
                  direction: 'ltr',
                }}
                inputStyle={{ direction: 'rtl' }}
              />
            </div>
            <div style={styles.calendarWrapper}>
              <label style={styles.calendarLabel}>תאריך סיום</label>
              <Calendar
                value={endDate}
                onChange={(e) => handleEndDateChange(e.value as Date)}
                dateFormat="dd/mm/yy"
                showIcon
                iconPos="right"
                style={{
                  height: '36px',
                  width: '100%',
                  direction: 'ltr',
                }}
                inputStyle={{ direction: 'rtl' }}
              />
            </div>
          </div>
        </CustomExpander>
      </div>
      <div style={styles.buttonContainer}>
        <Button
          label="אישור"
          icon="pi pi-check"
          style={styles.approveButton}
          onClick={handleApprove}
          disabled={!startDate || !endDate}
        />
      </div>
    </div>
  );
};
